var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyalIconGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20943_44379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3366 18.5599C13.0689 19.1617 12.892 19.8149 12.8242 20.4998L18.4887 19.2788C18.7564 18.6771 18.9332 18.0238 19.0011 17.3389L13.3366 18.5599Z",
    fill: "#4B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4876 15.6209C18.7553 15.0192 18.9322 14.3659 19 13.681L14.5876 14.6326V12.8033L18.4875 11.9629C18.7551 11.3611 18.9321 10.7079 18.9999 10.0229L14.5874 10.9738V4.39479C13.9113 4.77975 13.3109 5.29216 12.8227 5.89658V11.3542L11.0581 11.7346V3.5C10.3819 3.88482 9.78149 4.39736 9.29338 5.00179V12.1148L5.34489 12.9656C5.07722 13.5673 4.90015 14.2206 4.83224 14.9055L9.29338 13.9442V16.2479L4.51239 17.2782C4.24472 17.8799 4.06779 18.5332 4 19.2181L9.00436 18.1397C9.41174 18.0538 9.76187 17.8095 9.98951 17.4734L10.9073 16.0937V16.0934C11.0026 15.9507 11.0581 15.7786 11.0581 15.5932V13.5638L12.8227 13.1835V16.8422L18.4875 15.6206L18.4876 15.6209Z",
    fill: "#4B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20943_44379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white",
    transform: "translate(4 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalIconGrey);
export default __webpack_public_path__ + "static/media/riyal-icon-grey.6c897e43c8ea8dc1bee8fd8704bf0b55.svg";
export { ForwardRef as ReactComponent };